<template>
  <div>
    <b-modal
      ref="gift-card-coming-soon-modal"
      hide-footer
      modal-backdrop
      hide-header
      id="gift-card-coming-soon-modal"
      centered
      size="md"
    >
      <div class="text-center" style="font-family: 'Open Sans', sans-serif;">
        <!-- Icon Container -->
        <div class="modal-icon-container">
          <div class="">
            <!-- Clock/Time Icon for "Coming Soon" -->
              <img src="../../../assets/images/giftcard1.png" alt="CanPay Gift Card" class="gift-card-image" style="width: 276px;margin-top: 20px;"/>
          </div>
        </div>
        
        <!-- Title -->
        <h3 class="text-gift-card-comming-soon">Coming Soon!</h3>
      
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "GiftCardComingSoonModal",
  data() {
    return {}
  },
  methods: {
    showModal() {
      console.log('🎯 GiftCardComingSoonModal.showModal called');
      
      if (this.$refs['gift-card-coming-soon-modal']) {
        console.log('📢 Calling modal.show()...');
        this.$refs['gift-card-coming-soon-modal'].show();
        
        // Ensure modal is visible after show
        this.$nextTick(() => {
          const modalElement = document.getElementById('gift-card-coming-soon-modal');
          console.log('🔍 Modal element:', modalElement);
          
          if (modalElement) {
            // Force display style if modal exists but is hidden
            modalElement.style.display = 'block';
            modalElement.style.zIndex = '1050';
            
            // Ensure backdrop is visible
            const backdrop = document.querySelector('.modal-backdrop');
            if (backdrop) {
              backdrop.style.display = 'block';
              backdrop.style.opacity = '0.5';
              backdrop.style.zIndex = '1040';
            }
          } else {
            console.log('🔄 Modal element not found, trying $bvModal...');
            if (this.$bvModal) {
              this.$bvModal.show('gift-card-coming-soon-modal');
            }
          }
        });
      } else {
        console.error('❌ Modal ref not found in showModal!');
        
        // Try using $bvModal as fallback
        if (this.$bvModal) {
          console.log('🔄 Trying $bvModal fallback...');
          this.$bvModal.show('gift-card-coming-soon-modal');
        }
      }
    },
    
    closeModal() {
      console.log('🔒 Closing modal...');
      if (this.$refs['gift-card-coming-soon-modal']) {
        this.$refs['gift-card-coming-soon-modal'].hide();
      } else if (this.$bvModal) {
        this.$bvModal.hide('gift-card-coming-soon-modal');
      }
    }
  }
}
</script>

<style scoped>
.text-gift-card-comming-soon{
            font-size: 32px;
        font-weight: 700;
        color: #179346;
        font-family: 'Open Sans', sans-serif;
        margin: 20px 0px 8px 0px;
}
/* Modal styling following existing patterns */
#gift-card-coming-soon-modal___BV_modal_body_ {
  background-color: #ffffff;
  border-radius: 12px;
  margin: 10px;
  padding: 30px 20px;
}

#gift-card-coming-soon-modal___BV_modal_content_ {
  background-color: #ffffff;
  border-radius: 12px;
}

/* Ensure modal is visible and properly layered */
#gift-card-coming-soon-modal {
  z-index: 1050 !important;
}

.modal-backdrop {
  z-index: 1040 !important;
}

/* Force modal visibility */
#gift-card-coming-soon-modal.modal.show {
  display: block !important;
}

#gift-card-coming-soon-modal.modal.fade.show {
  display: block !important;
}

div#gift-card-coming-soon-modal.modal {
  display: block !important;
}

.modal-backdrop.show {
  opacity: 0.5 !important;
}

/* Modal content styling */
.modal-icon-container {
  margin-bottom: 20px;
}

.modal-icon-circle {
  width: 100px;
  height: 100px;
  background-color: #f8f9fa;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  border: 3px solid #179346;
}

.modal-title {
  font-size: 24px;
  font-weight: 700;
  color: #179346;
  font-family: 'Open Sans', sans-serif;
  margin: 20px 0 15px 0;
}

.modal-message {
  font-size: 16px;
  font-weight: 400;
  color: #666666;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.5;
  margin: 0 0 30px 0;
  padding: 0 10px;
}

.modal-actions {
  margin-top: 20px;
}

.ok-button {
  background-color: #179346;
  color: white;
  border: none;
  padding: 12px 40px;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: 'Open Sans', sans-serif;
  min-width: 120px;
}

.ok-button:hover {
  background-color: #0f6b32;
}

.ok-button:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(23, 147, 70, 0.3);
}

/* Mobile responsive */
@media (max-width: 768px) {
  #gift-card-coming-soon-modal___BV_modal_body_ {
    padding: 25px 15px;
    margin: 5px;
  }
  
  .modal-icon-circle {
    width: 80px;
    height: 80px;
  }
  
  .modal-icon-circle svg {
    width: 40px;
    height: 40px;
  }
  
  .modal-title {
    font-size: 20px;
    margin: 15px 0 10px 0;
  }
  
  .modal-message {
    font-size: 14px;
    margin: 0 0 25px 0;
    padding: 0 5px;
  }
  
  .ok-button {
    padding: 10px 30px;
    font-size: 14px;
    min-width: 100px;
  }
}
</style>
